<template src="./rating-meter-field.html"></template>

<script lang="ts">
import domUtils from 'util/dom-utils'
import FieldGroup from 'objects/form/FieldGroup.vue'
import fieldGroupPropsMixin from 'objects/form/FieldGroupPropsMixin.vue'


export default {
  data() {
    return {
      boxRefs: [],
      hoverRating: 0
    }
  },
  props: {
    modelValue: { // the id of the associated rating, set via v-model
      type: Number,
      default: 0
    },
    // Array of ids and ratings. Value property is the rating.
    // Example,
    // [
    //   { id: 9, value: 1},
    //   { id: 10, value: 2},
    //   { id: 11, value: 3},
    //   { id: 12, value: 4},
    //   { id: 13, value: 5}
    // ]
    valueDefs: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  components: {
    'tt-field-group': FieldGroup
  },
  mixins: [fieldGroupPropsMixin],
  computed: {
    idsToRatings() {
      return this.valueDefs.reduce((acc, valueDef) => {
        acc[valueDef.id] = valueDef.value
        return acc
      }, {})
    },
    rating() {
      if (this.hoverRating) {
        return this.hoverRating
      }
      return this.idsToRatings[this.modelValue] || 0
    },
    ratingsToIds() {
      return this.valueDefs.reduce((acc, valueDef) => {
        acc[valueDef.value] = valueDef.id
        return acc
      }, {})
    }
  },
  methods: {
    ratingSelected(e, rating) {
      if (e.type !== 'keydown') {
        this.$emit('update:modelValue', this.ratingsToIds[rating])
        return
      }
      let newRating = 0
      if ([38, 39].indexOf(e.keyCode) > -1) {
        newRating = rating === 5 ? 1 : rating + 1
        domUtils.safeFocus(this.boxRefs[newRating - 1])
      } else if ([37, 40].indexOf(e.keyCode) > -1) {
        newRating = rating === 1 ? 5 : rating - 1
        domUtils.safeFocus(() => this.boxRefs[newRating - 1])
      } else if (rating === 1 && e.keyCode === 32) {
        newRating = 1
      }
      if (newRating > 0) {
        e.preventDefault()
        this.$emit('update:modelValue', this.ratingsToIds[newRating])
      }
      return false
    },
    ratingEnter(rating) {
      this.hoverRating = rating
    },
    ratingLeave() {
      this.hoverRating = 0
    },
    setBoxRef(el) {
      if (el) {
        this.boxRefs.push(el)
      }
    }
  },
  beforeUpdate() {
    this.boxRefs = []
  }
}
</script>

<style lang="scss" src="./rating-meter.scss"></style>
